var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"min-h has-text-align-center mb-4 mt-10 text-[1.5rem] uppercase leading-8 lg:mb-[54px] lg:mt-[90px] lg:min-h-fit lg:text-[2.5rem] lg:leading-[3rem]",attrs:{"id":"blog-title"}},[_vm._v("\n  "+_vm._s(_vm.$t("blog"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }